export const Roles = {
  PATIENT: "PATIENT",

  CONSULTANT: "CONSULTANT",
};
